import React, {Component} from 'react';
import {
	Box,
	Grid,
  Button,
  Typography,
  TextField,
} from '@material-ui/core';
import {
	Page
} from '../../../components';
import axios from "../../../plugins/axios";
import {withStyles} from '@material-ui/styles';
import {store} from "react-notifications-component";

class SystemSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			listSettings: [],

			groupSystem: [],

			formSystemSettings: {},
			formSettingClear: {
				clearOn: false,

				deleteTo: null,
				saveDay: 365
			},
		}
	}

	componentDidMount = () => {
		this.onLoadSettings()
	}

	onLoadSettings = () => {
		axios('get', '/settings/get').then(response => {
			let settings = response.data;
			let groupSystem = [];

			for (let key in settings) {
				let setting = settings[key];

				if (setting.group === 'system') {
					groupSystem.push(setting)
				}
			}


			this.setState({
				groupSystem
			})
		}).catch(error => {

		})
	}

	onChangeSystemSettings = (groupSystem) => {
		this.setState({
			groupSystem
		})
	}

	onChangeSettingClear = (formSettingClear) => {
		this.setState({
			formSettingClear
		})
	}

	onSaveForm = () => {
		let body = {};

		this.state.groupSystem.map(item => {
			body[item.key] = item.value;
		})

		axios('post', '/settings/save', body).then(response => {
			store.addNotification({
				title: 'Успешно',
				message: 'Настройки системы изменены',
				type: 'success',
				insert: 'top',
				container: 'bottom-left',
				dismiss: {
					duration: 3000,
					onScreen: false,
					pauseOnHover: true,
					delay: 0
				}
			});

			this.onLoadSettings()
		})
	}

	toRouteHome = () => {
		this.props.history.push('/dashboard')
	}

	render() {
		const {classes} = this.props;

		return (
			<Page title="Настройки системы">
        <Grid container justify="center">
          <Grid item xs={12} md={8} lg={6}>
            <Box boxShadow={1} bgcolor="white" borderRadius={4} p={3}>
              <Box mb={3}>
                <Typography variant="h4">Настройки системы</Typography>
              </Box>

              <SystemSetting
                form={this.state.groupSystem}
                onChangeForm={this.onChangeSystemSettings}
                classes={classes}
              />

              <Box mt={3}>
                <Grid container spacing={1}>
                  <Grid item>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={this.onSaveForm}
                    >
                      Сохранить изменения
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={this.toRouteHome}
                    >
                      Отменить
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
			</Page>
		);
	}
}

const SystemSetting = React.forwardRef((props) => {
  const {
    form,
    onChangeForm,
    classes
  } = props;

  const handleFormChange = (event) => {
    let newForm = form;
    let item = event.target;
    let name = item.name;
    let value = item.value;

    let object = newForm.find(item => item.key === name)
    object.value = value;

    onChangeForm(newForm)
  }

  const visibleSettingKeys = ['SettingKeyFeedbackEmails', 'feedback.emails'];

  return (
    <Grid container spacing={2}>
      {
        form
          .filter((setting) => visibleSettingKeys.includes(setting.key))
          .map((setting, idx) => {
          return (
            <Grid key={`setting-item-${ idx }`} item xs={12}>
              <Typography variant="formTitle">
                {setting.title}
              </Typography>
              <TextField
                className={classes.field}
                name={setting.key}
                value={setting.value}
                onChange={handleFormChange}
                variant="outlined"
                fullWidth
                type={(setting.type == 'integer') ? 'number' : 'text'}
              />
            </Grid>
          )
        })
      }
    </Grid>
  )
});

const styles = {
  field: {
    width: '100%',
  },
};

export default withStyles(styles)(SystemSettings)
